(function () {
  'use strict';

  if (window.__nucleusImageZoomInit) return;
  window.__nucleusImageZoomInit = true;

  var DESKTOP_MIN = 769;
  var ZOOM_LEVEL = 2.5;
  var ZOOM_SIZE = 240;

  function shouldInitZoom() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function updateZoomPosition(event, image, zoomContainer) {
    var rect = image.getBoundingClientRect();
    var zoomSize = ZOOM_SIZE;
    var mouseX = event.clientX - rect.left;
    var mouseY = event.clientY - rect.top;
    var percentX = Math.min(Math.max(mouseX / rect.width, 0), 1);
    var percentY = Math.min(Math.max(mouseY / rect.height, 0), 1);
    var naturalW = image.naturalWidth || image.width;
    var naturalH = image.naturalHeight || image.height;
    var backgroundSizeX = naturalW * ZOOM_LEVEL;
    var backgroundSizeY = naturalH * ZOOM_LEVEL;

    zoomContainer.style.backgroundSize = backgroundSizeX + 'px ' + backgroundSizeY + 'px';
    zoomContainer.style.backgroundPosition =
      (-percentX * (backgroundSizeX - zoomSize)) + 'px ' +
      (-percentY * (backgroundSizeY - zoomSize)) + 'px';

    var left = event.clientX + 20;
    var top = event.clientY + 20;

    if (left + zoomSize > window.innerWidth - 8) {
      left = event.clientX - zoomSize - 20;
    }
    if (top + zoomSize > window.innerHeight - 8) {
      top = event.clientY - zoomSize - 20;
    }

    zoomContainer.style.left = left + 'px';
    zoomContainer.style.top = top + 'px';
  }

  function setupImageZoom(image) {
    if (!image || image.dataset.zoomInit === 'true') return;

    var zoomUrl = image.getAttribute('data-zoom-image');
    if (!zoomUrl) return;

    image.dataset.zoomInit = 'true';
    var zoomContainer = null;

    image.addEventListener('mouseenter', function (event) {
      if (!shouldInitZoom()) return;

      if (!zoomContainer) {
        zoomContainer = document.createElement('div');
        zoomContainer.className = 'zoom-container';
        zoomContainer.setAttribute('aria-hidden', 'true');
        document.body.appendChild(zoomContainer);
      }

      zoomContainer.style.backgroundImage = "url('" + zoomUrl.replace(/'/g, "\\'") + "')";
      zoomContainer.style.display = 'block';
      updateZoomPosition(event, image, zoomContainer);
    });

    image.addEventListener('mousemove', function (event) {
      if (zoomContainer && zoomContainer.style.display === 'block') {
        updateZoomPosition(event, image, zoomContainer);
      }
    });

    image.addEventListener('mouseleave', function () {
      if (zoomContainer) {
        zoomContainer.style.display = 'none';
      }
    });
  }

  function initProductZoom() {
    document.querySelectorAll('.product-main-image:not([data-zoom-init])').forEach(setupImageZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductZoom);
  } else {
    initProductZoom();
  }
})();
